export const MACHINE_ID = 'FILE_UPLOADER_MACHINE'

export const States = {
   IDLE: 'IDLE',

   FETCHING_PRE_SIGNED_URL: 'FETCHING_PRE_SIGNED_URL',
   FAILED_FETCHING_PRE_SIGNED_URL: 'FAILED_FETCHING_PRE_SIGNED_URL',

   FETCHING_PRE_SIGNED_URL_POST_PARAMS: 'FETCHING_PRE_SIGNED_URL_POST_PARAMS',
   FAILED_FETCHING_PRE_SIGNED_URL_POST_PARAMS:
      'FAILED_FETCHING_PRE_SIGNED_URL_POST_PARAMS',

   UPLOADING_FILE_TO_AWS: 'UPLOADING_FILE_TO_AWS',
   FAILED_UPLOADING_FILE_TO_AWS: 'FAILED_UPLOADING_FILE_TO_AWS',

   UPLOADING_FILE_TO_AWS_POST: 'UPLOADING_FILE_TO_AWS_POST',
   FAILED_UPLOADING_FILE_TO_AWS_POST: 'FAILED_UPLOADING_FILE_TO_AWS_POST',

   UPLOADING_FILE_TO_BACKEND: 'UPLOADING_FILE_TO_BACKEND',
   FAILED_UPLOADING_FILE_TO_BACKEND: 'FAILED_UPLOADING_FILE_TO_BACKEND',
   SUCCESS_FILE_UPLOADING: 'SUCCESS_FILE_UPLOADING',
   ACCESS_DENIED_TO_UPLOAD_FILE: 'ACCESS_DENIED_TO_UPLOAD_FILE',
   FRONTEND_VALIDATION_FAILURE: 'FRONTEND_VALIDATION_FAILURE'
}

export const Events = {
   RETRY: 'RETRY',
   ACCESS_DENIED: 'ACCESS_DENIED',
   ON_START: 'ON_START',
   UPLOAD_TO_BACKEND_FAILURE: 'UPLOAD_TO_BACKEND_FAILURE',
   FRONTEND_FAILURE: 'FRONTEND_FAILURE'
}

export const Tags = {
   LOADING: 'LOADING',
   FAILURE: 'FAILURE',
   SUCCESS: 'SUCCESS',
   ACCESS_DENIED: 'ACCESS_DENIED',
   HIDE_RETRY: 'HIDE_RETRY',
   IDLE: 'IDLE',
   HIDE_RETRY_ACTION: 'HIDE_RETRY_ACTION'
}

export const Services = {
   FETCH_PRE_SIGNED_URL: 'FETCH_PRE_SIGNED_URL',
   UPLOAD_FILE_TO_AWS: 'UPLOAD_FILE_TO_AWS',
   UPLOAD_FILE_TO_BACKEND: 'UPLOAD_FILE_TO_BACKEND',

   UPLOAD_FILE_TO_AWS_POST: 'UPLOAD_FILE_TO_AWS_POST',
   FETCH_PRE_SIGNED_URL_POST_PARAMS: 'FETCH_PRE_SIGNED_URL_POST_PARAMS'
}

export const Actions = {
   SAVE_PRE_SIGNED_URL: 'SAVE_PRE_SIGNED_URL',
   SAVE_PRE_SIGNED_URL_POST_PARAMS: 'SAVE_PRE_SIGNED_URL_POST_PARAMS',
   SAVE_URL: 'SAVE_URL',
   SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
   SET_UPLOAD_TO_BACKEND_ERROR_MESSAGE: 'SET_UPLOAD_TO_BACKEND_ERROR_MESSAGE',
   SET_FRONTEND_ERROR_MESSAGE: 'SET_FRONTEND_ERROR_MESSAGE'
}

export const Guards = {}
